<template>
  <VFlex class="owner-login" mt-4 text-xs-center>
    <BaseButton
      v-bind="{ ...$attrs, ...$props }"
      :text-color="textColor"
      :small="size === 'small'"
      :medium="size === 'medium'"
      :large="size === 'large'"
      class="owner-login-btn"
      @click="buttonClickAction"
    >
      {{ buttonText }}
    </BaseButton>
  </VFlex>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BaseOwnerLogin',
  props: {
    textColor: {
      type: String,
      default: 'grey darken-2',
    },
    size: {
      type: String,
      default: 'small',
    },
  },
  methods: {
    ...mapActions('auth', ['showAuthModal', 'requestLogOut']),
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
    buttonText() {
      return this.loggedIn ? 'Logout' : 'Owner Login'
    },
    buttonClickAction() {
      return this.loggedIn
        ? () => this.requestLogOut()
        : () => this.showAuthModal()
    },
  },
}
</script>

